import { Component, input, Signal, viewChild } from '@angular/core';
import { MenuItemType } from '../header.component';
import {
  MatSidenav,
  MatSidenavContainer,
  MatSidenavContent,
} from '@angular/material/sidenav';
import { environment } from '../../../../environments/environment';
import {
  MatActionList,
  MatListItem,
  MatListItemTitle,
} from '@angular/material/list';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatDivider } from '@angular/material/divider';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
  imports: [
    MatSidenavContainer,
    MatSidenav,
    MatActionList,
    MatIconButton,
    MatIcon,
    MatDivider,
    MatListItem,
    MatListItemTitle,
    MatSidenavContent,
    TranslateModule,
  ],
})
export class SidebarComponent {
  sidebar: Signal<MatSidenav> = viewChild('sidebar');

  name: Signal<string> = input();
  email: Signal<string> = input();
  navMenuItems: Signal<MenuItemType[]> = input();
  dropdownItems: Signal<MenuItemType[]> = input();

  onMenuOpen() {
    this.sidebar().open();
    if (!environment.production && window.unifiedPlatformScript) {
      window.unifiedPlatformCreateMenuItem();
    }
  }

  onClick(item: MenuItemType) {
    if (item.action) {
      item.action();
    }
  }
}
